export function StripeLine() {
  return (
    <svg
      width="17"
      height="6"
      viewBox="0 0 17 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="1.00989" width="17" height="4.0197" rx="1.2" fill="#9DB6E7" />
      <rect
        x="5.37317"
        y="0.95459"
        width="6.25378"
        height="4.07495"
        fill="#285FCA"
      />
    </svg>
  );
}
